package com.dotdrives.web.ui

import react.FC
import react.PropsWithChildren
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface DotCardProps : PropsWithChildren {
    var onClick: (() -> Unit)?
    var className: String?
}

val DotCard = FC<DotCardProps> { props ->
    val classes = listOfNotNull(
        "dot-card",
        "dot-card-clickable".takeIf { props.onClick != null },
        props.className,
    ).joinToString(" ")

    if (props.onClick != null) {
        button {
            type = ButtonType.buttonType
            className = ClassName(classes)
            onClick = { props.onClick?.invoke() }
            +props.children
        }
    } else {
        div {
            className = ClassName(classes)
            +props.children
        }
    }
}
